import React from 'react';
import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

const StyledHeader = styled.div`
  margin-top: 20px;
  margin-bottom: 14px;
`;

const SectionHeader = ({ children }) => (
  <StyledHeader>
    <Typography variant="h5" component="h2" style={{ color: '#00c752' }}>
      {children}
    </Typography>
  </StyledHeader>
);

export default SectionHeader;
